export default __webpack_public_path__ + "static/media/75-min.27e2b43a.jpg";